import React from 'react'
import Aboutus from '../Component/Aboutus'

const Abouttus = () => {
  return (
    <div>
      <Aboutus/>
    </div>
  )
}

export default Abouttus
